module.exports = __webpack_public_path__ + "images/store_case_study/otachu-pic1_2d26db10a9e619446b76712bf1b77aa7.png";